import { Component } from '@angular/core';
import { LoginProvider } from './../../providers/login/login.provider';
import { ConfigService } from './../../providers/config-service';
import {UserProvider} from "../../providers/user/user.provider";
import {
  NavController,
  NavParams,
  ToastController,
  LoadingController,
  AlertController,
  Events,
  Loading
} from 'ionic-angular';
import { HomePage } from '../home/home';
import { EcoEnelEmpresasPage } from '../ecoenel-empresas/ecoenel-empresas';
import { EsqueciSenhaPage } from '../esqueci-senha/esqueci-senha';

@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})
export class LoginPage {
  username: string = '';
  password: string = '';
  saveUsername: boolean = true;
  usernameFocused: boolean = false;
  passwordFocused: boolean = false;

  private loading: Loading | null = null;

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              public toastCtrl: ToastController,
              public alertCtrl: AlertController,
              public _loadingController: LoadingController,
              private loginProvider: LoginProvider,
              public configService: ConfigService,
              private userProvider: UserProvider,
              private events: Events) {}

  ionViewDidLoad() {
    // Load saved username from localStorage if available
    const savedUsername = localStorage.getItem('savedUsername');
    if (savedUsername) {
      this.username = savedUsername;
    }
  }

  clearUsername() {
    this.username = '';
  }

  clearPassword() {
    this.password = '';
  }

  fazerLogin(login) {
    // Save username to localStorage if checkbox is checked
    if (this.saveUsername) {
      localStorage.setItem('savedUsername', this.username);
    } else {
      localStorage.removeItem('savedUsername');
    }

    this.loading = this._loadingController.create({ content: 'Efetuando login...' });
    let toast = this.toastCtrl.create({ duration: 1500 });

    this.loading.present();

    // Create login object with the current username and password
    const loginData = {
      usuario: this.username,
      senha: this.password
    };

    this.loginProvider.fazerLogin(loginData)
      .then(() => {
        toast.setMessage('Logado! Carregando ambiente...');
        toast.present();
        this.afterLogin();
    })
      .catch((err:any) => {
        toast.setMessage('Login ou senha inválido : ' + err);
        toast.present();
        if (this.loading) {
          this.loading.dismiss();
          this.loading = null;
        }
    });
  }

  /**
   * Faz as ações necessárias após carregar o token de acesso do usuário
   */
  private afterLogin() {
    this.userProvider.getUserAuth()
      .toPromise()
      .then((user) => {
        if (this.loading) {
          this.loading.dismiss();
          this.loading = null;
        }

        // Disparar evento para carregar menu dinâmico
        this.events.publish('user:loggedIn', user);

        // Redirecionar baseado no perfil
        var perfilNome = (user && user.perfil && user.perfil.nome) ? user.perfil.nome : '';
        var perfisEcoEnel = ['GRANDE GERADOR', 'RECICLADOR'];

        if (perfisEcoEnel.indexOf(perfilNome) !== -1) {
          this.navCtrl.setRoot(EcoEnelEmpresasPage);
        } else {
          this.navCtrl.setRoot(HomePage);
        }
      })
  }

  esqueciSenha() {
    this.navCtrl.push(EsqueciSenhaPage);
  }

}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts